module.exports = __webpack_public_path__ + "img/Email-Template-generate.02126be4.gif";